// Single source of truth for the parish logo URL (transparent PNG)
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_mabuhay-community/artifacts/6e35rjbr_francis%20logo%20no%20background.png";
